// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./editprofileform.css";
// import { jwtDecode } from "jwt-decode";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";

// const EditProfileForm = ({ user, onClose, onProfileUpdate }) => {
//   const [formData, setFormData] = useState({
//     firstName: user?.FirstName || "",
//     lastName: user?.LastName || "",
//     email: user?.email || "",
//     mobile: user?.mobile || "",
//     city: user?.city || "",
//     gender: user?.gender || "",
//     address: user?.Address || "",
//   });
//   const [selectedFile, setSelectedFile] = useState(null);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleFileChange = (e) => {
//     setSelectedFile(e.target.files[0]);
//   };

//   // Disable background scroll when modal is open
//     useEffect(() => {
//       document.body.style.overflow = 'hidden';
//       return () => {
//         document.body.style.overflow = 'auto';
//       };
//     }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // Update user profile
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id;
//       const extractedUserId = userId.startsWith("user-")
//         ? userId.split("user-")[1]
//         : userId;

//       const response = await fetch(
//         `http://localhost:4001/user/${extractedUserId}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       if (!response.ok) {
//         console.error("Failed to update profile");
//         return;
//       }

//       // Upload image if a file is selected
//       if (selectedFile) {
//         const formData = new FormData();
//         formData.append("image", selectedFile);

//         const token = localStorage.getItem("token");
//         const decodedToken = jwtDecode(token);
//         const userId = decodedToken.Id;
//         const extractedUserId = userId.startsWith("user-")
//           ? userId.split("user-")[1]
//           : userId;

//         const imageUploadResponse = await axios.post(
//           `http://localhost:4001/upload/${extractedUserId}`,
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );

//         if (imageUploadResponse.status === 200) {
//           console.log(
//             "Image uploaded successfully:",
//             imageUploadResponse.data.imagePath
//           );
//         } else {
//           console.error("Failed to upload image");
//         }
//       }

//       console.log("Profile updated successfully");
//       onProfileUpdate();
//       onClose();
//     } catch (error) {
//       console.error("Error updating profile:", error);
//     }
//   };

//   return (
//     <div className="edit-profile-form-container">
//       <div className="edit-profile-form">
//         <div className="edit-form-header">
//           <div className="edit-form-header-top">
//             <h2>Edit Profile</h2>
//             <button className="edit-close-button" onClick={onClose}>
//               <FontAwesomeIcon icon={faTimes} />
//             </button>
//           </div>
//           <div className="edit-underline"></div>
//         </div>

//         <form onSubmit={handleSubmit}>
//           <div className="edit-form-row">
//             <div className="edit-form-col">
//               <label>First name</label>
//               <input
//                 className="edit-input"
//                 type="text"
//                 name="firstName"
//                 value={formData.firstName}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="edit-form-col">
//               <label>Last name</label>
//               <input
//                 className="edit-input"
//                 type="text"
//                 name="lastName"
//                 value={formData.lastName}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>
//           <div className="edit-form-row">
//             <div className="edit-form-col">
//               <label>Email</label>
//               <input
//                 className="edit-input"
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="edit-form-col">
//               <label>Mobile</label>
//               <input
//                 className="edit-input"
//                 type="tel"
//                 name="mobile"
//                 value={"0" + formData.mobile}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>
//           <div className="edit-form-row">
//             <div className="edit-form-col">
//               <label>City</label>
//               <select
//                 id="city"
//                 className="edit-input"
//                 name="city"
//                 value={formData.city}
//                 onChange={handleChange}
//               >
//                 <option value="">Select your City</option>
//                 <option value="Dhaka">Dhaka</option>
//                 <option value="Chattogram">Chattogram</option>
//                 <option value="Barishal">Barishal</option>
//                 <option value="Sylhet">Sylhet</option>
//                 <option value="Rajshahi">Rajshahi</option>
//                 <option value="Khulna">Khulna</option>
//                 <option value="Rangpur">Rangpur</option>
//                 <option value="Maymensingh">Maymensingh</option>
//               </select>
//             </div>
//             <div className="edit-form-col">
//               <label>Gender</label>
//               <select
//                 id="gender"
//                 className="edit-input"
//                 name="gender"
//                 value={formData.gender}
//                 onChange={handleChange}
//               >
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//               </select>
//             </div>
//           </div>
//           <div className="edit-form-row">
//             <div className="edit-form-col">
//               <label>Address</label>
//               <input
//                 className="edit-input"
//                 type="text"
//                 name="address"
//                 value={formData.address}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="edit-form-col">
//               <label>Upload Profile Image</label>
//               <input
//                 className="edit-input-image"
//                 type="file"
//                 // value={formData.imagePath}
//                 onChange={handleFileChange}
//               />
//             </div>
//           </div>
//           <button type="submit" className="update-button">
//             Update
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditProfileForm;


// ***** All checked and okay Edit Profile Form (23-6-25) ***** //





// ***** Translate EN BN with new update (23-6-25) ***** //

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./editprofileform.css";
import { jwtDecode } from "jwt-decode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { URL } from "../../../config";

const EditProfileForm = ({ user, onClose, onProfileUpdate }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: user?.FirstName || "",
    lastName: user?.LastName || "",
    // email: user?.email || "",
    // mobile: user?.mobile || "",
    city: user?.city || "",
    // gender: user?.gender || "",
    area:      user?.area      || "",
    address: user?.Address || "",
  });
  const [selectedFile, setSelectedFile] = useState(null);

  const [divisions, setDivisions] = useState([]);      // [{Id, name, ...}]
  const [areas, setAreas]         = useState([]);      // [{Id, name}]
  const [selectedCityId, setSelectedCityId] = useState(""); // division Id (string)


  // Load active divisions ("cities")
useEffect(() => {
  const loadDivisions = async () => {
    try {
      const { data } = await axios.get(`${URL}/locations/divisions`);
      const list = Array.isArray(data) ? data : [];
      setDivisions(list);

      // Preselect based on user's current city name
      if (user?.city) {
        const match = list.find(
          (d) => (d.name || "").toLowerCase() === String(user.city).toLowerCase()
        );
        if (match) {
          setSelectedCityId(String(match.Id));
          await loadAreas(match.Id);
        }
      }
    } catch {
      setDivisions([]);
    }
  };
  loadDivisions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

// Load areas for a division
const loadAreas = async (divisionId) => {
  if (!divisionId) {
    setAreas([]);
    return;
  }
  try {
    const { data } = await axios.get(`${URL}/locations/areas`, {
      params: { divisionId },
    });
    setAreas(Array.isArray(data) ? data : []);
  } catch {
    setAreas([]);
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // Disable background scroll when modal is open
    useEffect(() => {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'auto';
      };
    }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Update user profile
      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const userId = decodedToken.Id;
      const extractedUserId = userId.startsWith("user-")
        ? userId.split("user-")[1]
        : userId;

      const response = await fetch(
        `${URL}/user/${extractedUserId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        console.error("Failed to update profile");
        return;
      }

      // Upload image if a file is selected
      if (selectedFile) {
        const formData = new FormData();
        formData.append("image", selectedFile);

        const token = localStorage.getItem("token");
        const decodedToken = jwtDecode(token);
        const userId = decodedToken.Id;
        const extractedUserId = userId.startsWith("user-")
          ? userId.split("user-")[1]
          : userId;

        const imageUploadResponse = await axios.post(
          `${URL}/upload/${extractedUserId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (imageUploadResponse.status === 200) {
          console.log(
            "Image uploaded successfully:",
            imageUploadResponse.data.imagePath
          );
        } else {
          console.error("Failed to upload image");
        }
      }

      console.log("Profile updated successfully");
      onProfileUpdate();
      onClose();
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  return (
    <div className="edit-profile-form-container">
      <div className="edit-profile-form">
        <div className="edit-form-header">
          <div className="edit-form-header-top">
            {/* <h2>Edit Profile</h2> */}
            <h2>{t('userEditProfileForm.title')}</h2>
            <button className="edit-close-button" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="edit-underline"></div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="edit-form-row">
            <div className="edit-form-col">
              {/* <label>First name</label> */}
              <label>{t('userEditProfileForm.firstName')}</label>
              <input
                className="edit-input"
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            <div className="edit-form-col">
              {/* <label>Last name</label> */}
              <label>{t('userEditProfileForm.lastName')}</label>
              <input
                className="edit-input"
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>
          {/* <div className="edit-form-row">
            <div className="edit-form-col">
              <label>{t('userEditProfileForm.email')}</label>
              <input
                className="edit-input"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="edit-form-col">
              <label>{t('userEditProfileForm.mobile')}</label>
              <input
                className="edit-input"
                type="tel"
                name="mobile"
                value={"0" + formData.mobile}
                onChange={handleChange}
              />
            </div>
          </div> */}
          <div className="edit-form-row">
            <div className="edit-form-col">
              {/* <label>{t('userEditProfileForm.city')}</label>
              <select
                id="city"
                className="edit-input"
                name="city"
                value={formData.city}
                onChange={handleChange}
              >
                <option value="">{t('userEditProfileForm.cityOptions.select')}</option>
                <option value="Dhaka">{t('userEditProfileForm.cityOptions.dhaka')}</option>
                <option value="Chattogram">{t('userEditProfileForm.cityOptions.chattogram')}</option>
                <option value="Barishal">{t('userEditProfileForm.cityOptions.barishal')}</option>
                <option value="Sylhet">{t('userEditProfileForm.cityOptions.sylhet')}</option>
                <option value="Rajshahi">{t('userEditProfileForm.cityOptions.rajshahi')}</option>
                <option value="Khulna">{t('userEditProfileForm.cityOptions.khulna')}</option>
                <option value="Rangpur">{t('userEditProfileForm.cityOptions.rangpur')}</option>
                <option value="Mymensingh">{t('userEditProfileForm.cityOptions.mymensingh')}</option>

              </select> */}

              <label>{t('userEditProfileForm.city')}</label>
                  <select
                    id="city"
                    className="edit-input"
                    name="city"
                    value={selectedCityId}
                    onChange={async (e) => {
                      const id = e.target.value;
                      setSelectedCityId(id);
                      setAreas([]);
                      // Reset city/area in payload first
                      setFormData((prev) => ({ ...prev, city: "", area: "" }));

                      if (id) {
                        const div = divisions.find((d) => String(d.Id) === String(id));
                        // save city NAME in the payload (backend expects name)
                        setFormData((prev) => ({ ...prev, city: div?.name || "", area: "" }));
                        await loadAreas(id);
                      }
                    }}
                  >
                    <option value="">{t('userEditProfileForm.cityOptions.select')}</option>
                    {divisions.map((d) => (
                      <option key={d.Id} value={String(d.Id)}>
                        {d.name}
                      </option>
                    ))}
                  </select>
            </div>
            {/* <div className="edit-form-col">
              <label>{t('userEditProfileForm.gender')}</label>
              <select
                id="gender"
                className="edit-input"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="Male">{t('userEditProfileForm.genderOptions.male')}</option>
                <option value="Female">{t('userEditProfileForm.genderOptions.female')}</option>
              </select>
            </div> */}

            {/* <div className="edit-form-col">
              <label>{t('userEditProfileForm.area')}</label>
              <input
                className="edit-input"
                type="text"
                name="area"
                value={formData.area}
                onChange={handleChange}
                placeholder={t('userEditProfileForm.area_ph') || 'e.g., Dhanmondi, Gulshan'}
              />
            </div> */}

            <div className="edit-form-col">
              <label>{t('userEditProfileForm.area')}</label>
              <select
                className="edit-input"
                name="area"
                value={formData.area}
                onChange={handleChange}
                disabled={!selectedCityId || areas.length === 0}
              >
                <option value="">
                  {t('servitor_signup.select_area') || 'Select Area'}
                </option>
                {areas.map((a) => (
                  <option key={a.Id} value={a.name}>
                    {a.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="edit-form-row">
            <div className="edit-form-col">
              {/* <label>Address</label> */}
              <label>{t('userEditProfileForm.address')}</label>
              <input
                className="edit-input"
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="edit-form-row">

            <div className="edit-form-col">
              {/* <label>Upload Profile Image</label> */}
              <label>{t('userEditProfileForm.uploadProfileImage')}</label>
              <input
                className="edit-input-image"
                type="file"
                // value={formData.imagePath}
                onChange={handleFileChange}
              />
            </div>

          </div>
          <button type="submit" className="update-button">
            {/* Update */}
            {t('userEditProfileForm.updateButton')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProfileForm;
